import React from 'react';
import { motion } from 'framer-motion';
interface DiaryEntryProps {
  title: string;
  date: string;
  content: React.ReactNode;
  index: number;
  rotation?: number;
}
export function DiaryEntry({
  title,
  date,
  content,
  index,
  rotation = 0
}: DiaryEntryProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} className="relative mb-12 last:mb-0" data-id="element-38">
      <div className="bg-cream-card p-6 md:p-8 rounded-lg shadow-md border border-brown/10 relative" style={{
      transform: `rotate(${rotation}deg)`
    }} data-id="element-39">
        {/* Tape decoration */}
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-24 h-6 bg-white/60 shadow-sm rotate-[-2deg] border border-black/5" data-id="element-40"></div>

        <div className="flex flex-col md:flex-row md:items-baseline justify-between mb-4 border-b border-brown/10 pb-4" data-id="element-41">
          <h3 className="font-handwriting text-3xl text-forest font-bold" data-id="element-42">
            {title}
          </h3>
          <span className="font-handwriting text-xl text-brown/70 mt-1 md:mt-0" data-id="element-43">
            {date}
          </span>
        </div>

        <div className="font-serif text-lg leading-relaxed text-gray-800 space-y-4" data-id="element-44">
          {content}
        </div>
      </div>
    </motion.div>;
}